/* SALTLAB – Kinderbackbuch-Seite
   Galerie, Lightbox/Zoom, Warenkorb (AJAX), Varianten, Sticky-Kaufleiste.
   Läuft nur auf dem Template product.kinderbackbuch. */
(function () {
  'use strict';
  if (window.__kbBookLoaded) return;
  window.__kbBookLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.kbMoneyFormat || '{{amount_with_comma_separator}} €');
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDot + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, withComma + '.' + parts[1]);
  }

  /* ---------------- Lightbox ---------------- */
  var lightbox, lbImg, lbPrev, lbNext, lbItems = [], lbIndex = 0, lbReturnFocus = null;

  function buildLightbox() {
    if (lightbox) return;
    lightbox = document.createElement('dialog');
    lightbox.className = 'kb-lightbox';
    lightbox.setAttribute('aria-label', 'Bildansicht');
    lightbox.innerHTML =
      '<div class="kb-lightbox__scroller"><img class="kb-lightbox__img" alt=""></div>' +
      '<button type="button" class="kb-lightbox__close" aria-label="Schließen">' + ICON_CLOSE + '</button>' +
      '<button type="button" class="kb-lightbox__nav kb-lightbox__nav--prev" aria-label="Vorheriges Bild">' + ICON_PREV + '</button>' +
      '<button type="button" class="kb-lightbox__nav kb-lightbox__nav--next" aria-label="Nächstes Bild">' + ICON_NEXT + '</button>';
    document.body.appendChild(lightbox);
    lbImg = $('.kb-lightbox__img', lightbox);
    lbPrev = $('.kb-lightbox__nav--prev', lightbox);
    lbNext = $('.kb-lightbox__nav--next', lightbox);

    $('.kb-lightbox__close', lightbox).addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', function () { showLightbox(lbIndex - 1); });
    lbNext.addEventListener('click', function () { showLightbox(lbIndex + 1); });
    lbImg.addEventListener('click', function () { lightbox.classList.toggle('is-zoomed'); });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('kb-lightbox__scroller')) closeLightbox();
    });
    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showLightbox(lbIndex - 1);
      if (e.key === 'ArrowRight') showLightbox(lbIndex + 1);
    });
    lightbox.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (lbReturnFocus) lbReturnFocus.focus();
    });
  }

  function showLightbox(i) {
    if (!lbItems.length) return;
    lbIndex = (i + lbItems.length) % lbItems.length;
    lightbox.classList.remove('is-zoomed');
    lbImg.src = lbItems[lbIndex].src;
    lbImg.alt = lbItems[lbIndex].alt || '';
    var multi = lbItems.length > 1;
    lbPrev.hidden = !multi;
    lbNext.hidden = !multi;
  }

  function openLightbox(items, index, trigger) {
    buildLightbox();
    lbItems = items;
    lbReturnFocus = trigger || null;
    showLightbox(index || 0);
    document.documentElement.style.overflow = 'hidden';
    if (typeof lightbox.showModal === 'function') lightbox.showModal();
    else lightbox.setAttribute('open', '');
  }

  function closeLightbox() {
    if (!lightbox) return;
    if (typeof lightbox.close === 'function') lightbox.close();
    else { lightbox.removeAttribute('open'); document.documentElement.style.overflow = ''; }
  }

  /* ---------------- Galerie ---------------- */
  function initGallery(root) {
    if (root.getAttribute('data-kb-ready')) return;
    root.setAttribute('data-kb-ready', '1');
    var track = $('.kb-gallery__track', root);
    if (!track) return;
    var slides = $$('.kb-gallery__slide', root);
    var thumbs = $$('.kb-gallery__thumb', root);
    var dots = $$('.kb-gallery__dot', root);
    var prev = $('.kb-gallery__arrow--prev', root);
    var next = $('.kb-gallery__arrow--next', root);
    var current = 0;

    var zoomItems = $$('[data-kb-zoom-src]', root).map(function (el) {
      return { src: el.getAttribute('data-kb-zoom-src'), alt: el.getAttribute('data-kb-zoom-alt') };
    });

    function goTo(i, smooth) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); });
      $$('.kb-gallery__zoom', root).forEach(function (b, n) { b.tabIndex = n === i ? 0 : -1; });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
        ticking = false;
      });
    }, { passive: true });

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.target.closest('.kb-gallery__thumbs')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    $$('.kb-gallery__zoom', root).forEach(function (btn, n) {
      btn.addEventListener('click', function () { openLightbox(zoomItems, n, btn); });
    });

    // Variantenbild anzeigen
    root.addEventListener('kb:media', function (e) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(e.detail.mediaId); });
      if (idx > -1) goTo(idx);
    });

    setActive(0);
  }

  /* ---------------- Einzelbilder (A+-Grafiken) zoomen ---------------- */
  function initZoomables() {
    $$('[data-kb-zoom-single]:not([data-kb-ready])').forEach(function (btn) {
      btn.setAttribute('data-kb-ready', '1');
      btn.addEventListener('click', function () {
        openLightbox([{ src: btn.getAttribute('data-kb-zoom-src'), alt: btn.getAttribute('data-kb-zoom-alt') }], 0, btn);
      });
    });
  }

  /* ---------------- Warenkorb ---------------- */
  function refreshCartCount() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        $$('[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-count, .header__cart-count, cart-count').forEach(function (el) {
          el.textContent = count;
        });
        $$('.cart-count-bubble, .cart-bubble').forEach(function (el) { el.hidden = count === 0; el.classList.toggle('visually-hidden', count === 0); });
        // Events, auf die viele Online-Store-2.0-Themes (u. a. Horizon/Dawn-Familie) hören
        var detail = { resource: cart, sourceId: 'kb-book', data: { source: 'product-form-component', itemCount: count } };
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return cart;
      })
      .catch(function () {});
  }

  function addToCart(variantId, qty) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Das Buch konnte nicht in den Warenkorb gelegt werden.');
        return data;
      });
    }).then(function (data) {
      refreshCartCount();
      return data;
    });
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* Toast für Buttons außerhalb des Formulars (Sticky-Leiste, Zwischen-CTAs) */
  var toast;
  function showToast(message, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'kb kb-added';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:96px;z-index:60;width:min(92vw,440px);box-shadow:0 12px 30px rgba(0,0,0,.18);';
      document.body.appendChild(toast);
    }
    if (isError) {
      toast.innerHTML = '<p class="kb-added__title">' + message + '</p>';
    } else {
      toast.innerHTML =
        '<p class="kb-added__title">✓ ' + message + '</p>' +
        '<div class="kb-added__actions">' +
        '<a class="kb-added__cart" href="' + ROOT + 'cart">Zum Warenkorb</a>' +
        '<a class="kb-added__checkout" href="' + ROOT + 'checkout">Zur Kasse</a>' +
        '</div>';
    }
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 7000);
  }

  function initForms() {
    $$('[data-kb-form]:not([data-kb-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-kb-ready', '1');
      var form = $('form[action*="/cart/add"]', wrap);
      if (!form) return;
      var btn = $('[data-kb-submit]', form);
      var added = $('.kb-added', wrap);
      var error = $('.kb-error', wrap);
      var idInput = $('input[name="id"]', form);
      var qtyInput = $('input[name="quantity"]', form);

      // Mengenauswahl
      $$('[data-kb-qty]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          v += parseInt(b.getAttribute('data-kb-qty'), 10);
          qtyInput.value = Math.max(1, Math.min(99, v));
        });
      });

      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // Fallback: normaler Formular-Submit → /cart
        e.preventDefault();
        if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
        setLoading(btn, true);
        if (error) error.classList.remove('is-visible');
        addToCart(idInput.value, qtyInput ? qtyInput.value : 1)
          .then(function () {
            if (added) {
              added.classList.add('is-visible');
              var link = $('.kb-added__checkout', added);
              if (link) link.focus({ preventScroll: true });
            }
          })
          .catch(function (err) {
            if (error) { error.textContent = err.message; error.classList.add('is-visible'); }
          })
          .finally(function () { setLoading(btn, false); });
      });
    });

    // Einfache Kaufbuttons (Sticky-Leiste, Zwischen-CTAs)
    $$('[data-kb-add]:not([data-kb-ready])').forEach(function (btn) {
      btn.setAttribute('data-kb-ready', '1');
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-kb-add') || currentVariantId();
        if (!id) return;
        setLoading(btn, true);
        addToCart(id, 1)
          .then(function () { showToast('Das Buch liegt im Warenkorb.'); })
          .catch(function (err) { showToast(err.message, true); })
          .finally(function () { setLoading(btn, false); });
      });
    });
  }

  function currentVariantId() {
    var input = $('#kb-main-form input[name="id"]');
    return input ? input.value : null;
  }

  /* ---------------- Varianten (falls vorhanden) ---------------- */
  function initVariants() {
    var dataEl = $('#kb-variants-json');
    var select = $('[data-kb-variant-select]');
    if (!dataEl || !select) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      $$('input[name="id"]').forEach(function (i) { i.value = v.id; });
      $$('[data-kb-add]').forEach(function (b) { b.setAttribute('data-kb-add', v.id); });
      $$('[data-kb-price]').forEach(function (p) { p.textContent = formatMoney(v.price); });
      $$('[data-kb-submit]').forEach(function (b) {
        b.disabled = !v.available;
        var label = $('.kb-btn__label', b);
        if (label) label.textContent = v.available ? b.getAttribute('data-label-available') : b.getAttribute('data-label-soldout');
      });
      $$('[data-kb-stock]').forEach(function (s) {
        s.classList.toggle('kb-stock--out', !v.available);
        s.textContent = v.available ? s.getAttribute('data-label-in') : s.getAttribute('data-label-out');
      });
      if (v.featured_media_id) {
        var g = $('[data-kb-gallery]');
        if (g) g.dispatchEvent(new CustomEvent('kb:media', { detail: { mediaId: v.featured_media_id } }));
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  /* ---------------- Sticky-Kaufleiste ---------------- */
  function initSticky() {
    var bar = $('[data-kb-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var watched = $$('[data-kb-buy-zone]');
    if (!watched.length) return;
    var state = new Map();
    var heroZone = watched[0];

    function update() {
      var anyVisible = false;
      state.forEach(function (v) { if (v) anyVisible = true; });
      var pastHero = heroZone.getBoundingClientRect().bottom < 0;
      var show = !anyVisible && pastHero;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('a, button', bar).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('kb-sticky-on', show);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { state.set(en.target, en.isIntersecting); });
      update();
    }, { threshold: 0 });
    watched.forEach(function (el) { state.set(el, true); io.observe(el); });
    window.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
  }

  /* ---------------- Start ---------------- */
  function init() {
    $$('[data-kb-gallery]').forEach(initGallery);
    initZoomables();
    initForms();
    initVariants();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme-Editor: nach Section-Änderung neu initialisieren
  document.addEventListener('shopify:section:load', function () {
    $$('[data-kb-gallery]').forEach(initGallery);
    initZoomables();
    initForms();
  });
})();